import React from 'react';
import clsx from 'clsx';

import { T8y } from 'ui';

import style from './costSummaryPanel.module.scss';

const CostSummaryPanel = ({ calculatedPrice, isBottomPanel }) => {
  return (
    <div
      className={clsx(
        style.costSummary,
        isBottomPanel && style.costSummaryBottom,
      )}
    >
      <T8y color="wilkoBlack" variant="t1" smVariant="t2" xsVariant="t1v1" bold>
        Subtotal
      </T8y>
      <T8y
        variant="t1"
        smVariant="t2"
        xsVariant="t1v1"
        color="wilkoBlack"
        className={style.costSummarySubtotalItemPrice}
        bold
      >
        {calculatedPrice !== 'TBD'
          ? `£${calculatedPrice?.toFixed(2)}`
          : calculatedPrice}
      </T8y>
    </div>
  );
};

export default CostSummaryPanel;
